<h2>{{data.title}}, veuillez patienter ... </h2>
<mat-divider></mat-divider>
<br>
<mat-spinner></mat-spinner>
